export const buildCommonLog = (
  category?: string,
  local?: {
    checkInDate?: string;
    checkOutDate?: string;
    capacityAdult: number;
    capacityChildAges: number[];
  },
  global?: {
    checkInDate?: string;
    checkOutDate?: string;
    capacityRooms?: { adult: number; child: number[] }[];
  },
) => {
  if (!category) {
    return {};
  }

  if (category === 'LOCAL_ACCOMMODATION') {
    return {
      checkInDate: local?.checkInDate ?? '',
      checkOutDate: local?.checkOutDate ?? '',
      roomPeople: [
        {
          adult: local?.capacityAdult,
          childages: local?.capacityChildAges,
        },
      ],
    };
  }

  if (category === 'GLOBAL_ACCOMMODATION') {
    return {
      checkInDate: global?.checkInDate,
      checkOutDate: global?.checkOutDate,
      roomPeople: global?.capacityRooms?.map((room) => ({
        adult: room.adult,
        childages: room.child,
      })),
    };
  }

  return {};
};
